/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Newer_Version_TitleInputs */

const en_ui_newer_version_title = /** @type {(inputs: Ui_Newer_Version_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PaceVault was updated`)
};

const de_ui_newer_version_title = /** @type {(inputs: Ui_Newer_Version_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PaceVault wurde aktualisiert`)
};

/**
* | output |
* | --- |
* | "PaceVault was updated" |
*
* @param {Ui_Newer_Version_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_newer_version_title = /** @type {((inputs?: Ui_Newer_Version_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Newer_Version_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_newer_version_title(inputs)
	return de_ui_newer_version_title(inputs)
});